import { useEffect, useRef } from 'react';
import { useSelector, useStore } from 'react-redux';

import { useDuplexerInstance } from '../../common/hooks/useDuplexerInstance';
import { selectStartChatLoading } from '../../common/selectors/chat';
import { MessageReadSubscriber } from '../../messageChannel';
import { renderModel } from '../../util/renderModel';
import { ChatbotMessageSubscriberWithRead } from '../events/subscribe/ChatbotMessageSubscriberWithRead';

const { duplexer } = renderModel.get();
const { messageChannels } = duplexer;

/**
 * Hook responsible for getting new messages from duplexer and updating read status for a message.
 */
export const useMessageSubscriber = () => {
  const store = useStore();
  const duplexerInstance = useDuplexerInstance();

  const shouldIgnoreMessages = Boolean(useSelector(selectStartChatLoading));

  const messageSubscriberRef = useRef<ChatbotMessageSubscriberWithRead | undefined>(undefined);

  useEffect(() => {
    messageSubscriberRef.current = new ChatbotMessageSubscriberWithRead(
      duplexerInstance,
      messageChannels?.chatbotMessage,
      store,
    );
    const messageReadSubscriber = new MessageReadSubscriber(
      duplexerInstance,
      messageChannels?.chatbotMessage,
      store,
    );

    return () => {
      messageSubscriberRef.current?.unsubscribe();
      messageReadSubscriber.unsubscribe();
    };
  }, []);

  useEffect(() => {
    if (!messageSubscriberRef.current) {
      return;
    }
    messageSubscriberRef.current.forceIgnoreMessages = shouldIgnoreMessages;
  }, [shouldIgnoreMessages]);
};
